<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="deleteSatelite"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t(`mEditionBillingArtificialIntelligence.modalDelete.title.${tab}`) }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>

      <section
        key="modalSection"
        class="m-the-modal-section"
      >
        <p>
          {{ $t('mEditionBillingArtificialIntelligence.modalDelete.text') }}
          <b>{{ satelite.titulo }}</b>.
        </p>
        <small class="text-color-danger">
          {{ $t('mEditionBillingArtificialIntelligence.modalDelete.warning') }}
        </small>
      </section>

      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction
          :cancel-text="$t('mEditionBillingArtificialIntelligence.modalDelete.buttons.cancel')"
        />
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingArtificialIntelligenceModalDelete',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionBillingArtificialIntelligence.modalDelete.buttons.submit'),
        class: 'a-button-danger-primary',
        sending: false,
        type: 'submit'
      },

      satelite: {},
      sufijo: 'IaMensual',
      tab: 'mensual'
    }
  },

  created () {
    this.satelite = this.$modal.element.satelite
    this.sufijo = this.$modal.element.sufijo
    this.tab = this.$modal.element.tab
  },

  methods: {
    // Borrado logico en el core-api (responde 204 sin cuerpo)
    deleteSatelite () {
      if (this.buttonPrimary.sending) {
        return
      }

      this.buttonPrimary.sending = true

      this.$services.delete('satelite', `deleteSatelite${this.sufijo}`, {}, [this.satelite.id])
        .then(() => {
          this.$alerts.pushAlert('mEditionBillingArtificialIntelligence', 'deleteSatelite', 'success', 'a-alert-success')
          this.$modal.updateData('readSatelitesIa')
          this.$modal.closeModal()
        })
        .catch(() => {
          this.$alerts.pushAlert('mEditionBillingArtificialIntelligence', 'deleteSatelite', 'error', 'a-alert-danger')
        })
        .finally(() => {
          this.buttonPrimary.sending = false
        })
    }
  }
}
</script>
